import { render, staticRenderFns } from "./feedback-manage.vue?vue&type=template&id=1eb8fa53&"
import script from "./feedback-manage.vue?vue&type=script&lang=js&"
export * from "./feedback-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports